import { useMemo } from "react";
import { isEqual } from "@common/helpers/comparison";
import { DEFAULT_FILTERS, TransactionsFilters } from "./filters/lib";

export function useFiltersActive(currentFilters: TransactionsFilters): boolean {
    return useMemo(
        () => !isEqual(currentFilters, DEFAULT_FILTERS),
        [currentFilters],
    );
}
